import * as yup from 'yup';

const ProfileSchema = yup.object({
  name: yup.string().required('Name is required'),
  role: yup.string().required('Role is required'),
  specialities: yup
    .array()
    .of(
      yup.object({
        title: yup.string().required('Speciality is required'),
        value: yup.string().required('Speciality is required'),
      }),
    )
    .min(1, 'At least one speciality is required')
    .required('Specialities is required'),
  prescribesControlled: yup.boolean(),
  prescribesMAT: yup.boolean(),
  prescribesPsych: yup.boolean(),
  cashNoShowRate: yup.number().min(0, 'Cash no show rate should be 0 or greater').optional(),
  commercialNoShowRate: yup.number().min(0, 'Commercial no show rate should be 0 or greater').optional(),
  medicaidNoShowRate: yup.number().min(0, 'Medicaid no show rate should be 0 or greater').optional(),
});

export { ProfileSchema };
